export type ConsentManagerVendor = 'usercentrics' | 'consentmanagerde' | 'none';

export type ConsentRequirement = {
    services?: string[]; // z.B. ['GoogleAnalytics4']
    categories?: string[]; // optional, generisch: z.B. ['marketing']
};

export interface ConsentState {
    services: Record<string, boolean>; // Key: Service-Name ODER -ID → consented?
    categories: Record<string, boolean>; // konservativ berechnet (siehe Adapter)
}

export interface ConsentManager {
    name: ConsentManagerVendor;
    load(config: Record<string, any>): Promise<void>;
    isReady(): boolean;
    getState(): ConsentState;
    onChange(cb: (state: ConsentState) => void): () => void; // unsubscribe
    hasConsent(req: ConsentRequirement): boolean;
    showBanner(): void;
}

export const CONSENT_SERVICENAME_GA4 = 'GoogleAnalytics4';
